var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('textarea',{staticStyle:{"height":"411px"},attrs:{"id":_vm.uid},domProps:{"value":_vm.value},on:{"input":function($event){_vm.updateValue($event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }